/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbForfaitAuditeurDto } from './FcbForfaitAuditeurDto';
import {
    FcbForfaitAuditeurDtoFromJSON,
    FcbForfaitAuditeurDtoFromJSONTyped,
    FcbForfaitAuditeurDtoToJSON,
} from './FcbForfaitAuditeurDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbForfaitAuditeurDtoPaginatedResults
 */
export interface FcbForfaitAuditeurDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbForfaitAuditeurDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbForfaitAuditeurDto>}
     * @memberof FcbForfaitAuditeurDtoPaginatedResults
     */
    results?: Array<FcbForfaitAuditeurDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbForfaitAuditeurDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbForfaitAuditeurDtoPaginatedResults interface.
 */
export function instanceOfFcbForfaitAuditeurDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbForfaitAuditeurDtoPaginatedResultsFromJSON(json: any): FcbForfaitAuditeurDtoPaginatedResults {
    return FcbForfaitAuditeurDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbForfaitAuditeurDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbForfaitAuditeurDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbForfaitAuditeurDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbForfaitAuditeurDtoPaginatedResultsToJSON(value?: FcbForfaitAuditeurDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbForfaitAuditeurDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

